
import { createAction } from 'typesafe-actions';
import { Alert, Entry, ShipData, PortData, Species, Bulletin } from '../../services/types';

export const closeDisplays = createAction('CLOSE_DISPLAYS')();
export const toggleHighlight = createAction('TOGGLE_HIGHLIGHT')<number>();
export const toggleDisplays = createAction('TOGGLE_DISPLAYS')<Entry|Bulletin>();
export const toggleFullSize = createAction('TOGGLE_FULLSIZE')<string|null>();
export const setShowImages = createAction('SET_SHOW_IMAGES')<boolean>();
export const displayFirstEntry = createAction('DISPLAY_FIRST_ENTRY')();

export const toggleShip = createAction('TOGGLE_SHIP')<ShipData>();
export const togglePort = createAction('TOGGLE_PORT')<PortData>();

export const selectSpecies = createAction('TOGGLE_SPECIES')<Species>();
export const selectBulletin = createAction('TOGGLE_BULLETIN')<Bulletin>();

export const toggleLogin = createAction('TOGGLE_LOGIN')();

export const displayAlert = createAction('DISPLAY_ALERT')<Alert>();
